import { cn } from '@cannect/lib/utils'
import { AnchorHTMLAttributes, HTMLAttributes } from 'react'

export type TSoldByPillProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'>

const PillIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="shrink-0">
    <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z" />
    <path d="m8.5 8.5 7 7" />
  </svg>
)

export const SoldByPill = ({ className, ...props }: TSoldByPillProps) => (
  <a
    href="https://pill.com.br"
    target="_blank"
    rel="noopener noreferrer"
    className={cn(
      'inline-flex items-center gap-1 font-nunito text-xxs text-blue-600 hover:text-blue-800 hover:underline',
      className
    )}
    {...props}>
    <PillIcon />
    Vendido por Pill
  </a>
)

export type TSoldByPillTextProps = HTMLAttributes<HTMLSpanElement>

export const SoldByPillText = ({ className, ...props }: TSoldByPillTextProps) => (
  <span className={cn('inline-flex items-center gap-1 font-nunito text-xxs text-neutral-500', className)} {...props}>
    <PillIcon />
    Vendido por Pill
  </span>
)
